import { useSearchParams } from '../useSearchParams';
import { refParam } from '../../config/queryParams';
export function useRefParam() {
    var searchParams = useSearchParams()[0];
    var refString = searchParams.get(refParam);
    return { refString: refString };
}
